import { Box, IconButton, TextField } from "@mui/material";
import { Vec3 } from "../../models/SyntheticMap";
import * as THREE from "three";
import { SelectAll } from "@mui/icons-material";
import { FlexContainer } from "../../components/FlexContainer";

export function Vec3Editor({
  value,
  onChange,
  convertToDegrees,
  onSelect = null,
  boxWidth = 60
}: {
  value: Vec3,
  onChange: (value: Vec3) => void,
  convertToDegrees?: boolean,
  onSelect?: (() => void) | null,
  boxWidth?: number
}) {
  const handleChange = (axis: 'x' | 'y' | 'z', newValue: number) => {
    if (convertToDegrees && (axis === 'x' || axis === 'y' || axis === 'z')) {
      newValue = THREE.MathUtils.degToRad(newValue);
    }
    const newVec = { ...value };
    newVec[axis] = newValue;
    onChange(newVec);
  };
  const preprocessAxisValue = (axisValue: number) => {
    if (convertToDegrees) {
      return THREE.MathUtils.radToDeg(axisValue).toFixed(2); // Convert to degrees and format to 2 decimal places
    } else {
      return axisValue.toFixed(2); // Keep as is and format to 2 decimal places
    }
  }
  const anyValue = value as any;

  if (!onSelect) {
    return (
      <Box sx={{ display: 'flex', gap: 1 }}>
        {['x', 'y', 'z'].map(axis => (
          <TextField
            key={axis}
            type="number"
            value={preprocessAxisValue(anyValue[axis])}
            onChange={(e) => handleChange(axis as any, parseFloat(e.target.value))}
            variant="standard"
            size="small"
            sx={{ width: `${boxWidth}px` }}
          />
        ))}
      </Box>
    );
  }

  return (
    <FlexContainer>
      <Box sx={{ display: 'flex', gap: 1 }}>
        {['x', 'y', 'z'].map(axis => (
          <TextField
            key={axis}
            type="number"
            value={preprocessAxisValue(anyValue[axis])}
            onChange={(e) => handleChange(axis as any, parseFloat(e.target.value))}
            variant="standard"
            size="small"
            sx={{ width: `${boxWidth}px` }}
          />
        ))}
      </Box>
      <IconButton
        size='small'
        onClick={() => {
          onSelect();
        }}
      >
        <SelectAll />
      </IconButton>
    </FlexContainer>
  );
}